import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MFAVerificationChallengePage } from "../../components/pages/mfa/verification-challenge";
import { MFAExpiredPage } from "../../components/pages/mfa/expired";
import { NoMenuNavigationBar } from "../../components/parts/nomenu-navigation-bar";
import { post } from "../../lib/request";
import { endpoint } from "../../../../server/router/endpoint";
import { LoginVerifyRequest, LoginVerifyResponse } from "../../../../server/types/request/login";

type LocationState = { email?: string; token?: string } | null;

const verifyFailedMessage = "認証に失敗しました。コードを確認して、もう一度お試しください。";

/**
 * 追加のメール認証
 * - 多要素認証の後、最終ログインから一定期間経過している場合に表示する
 */
export const LoginVerifyContainer = () => {
	const navigate = useNavigate();
	// ログイン画面から渡されるチャレンジトークン（リロードすると失われる）
	const { email, token } = (useLocation().state as LocationState) ?? {};
	const [error, setError] = React.useState<string>();
	const [isPending, setIsPending] = React.useState<boolean>(false);

	const onSubmit = React.useCallback(
		(code: string) => {
			const request: LoginVerifyRequest = { code, token };
			setIsPending(true);
			return post<LoginVerifyResponse>(endpoint.loginVerify, request)
				.then((response) => {
					navigate(response.data.redirectUrl || "/", { replace: true });
				})
				.catch((error) => {
					setError(verifyFailedMessage);
					throw error;
				})
				.finally(() => setIsPending(false));
		},
		[navigate, token],
	);

	return (
		<>
			<NoMenuNavigationBar />
			{token ? (
				<MFAVerificationChallengePage email={email ?? ""} error={error} isPending={isPending} onSubmit={onSubmit} />
			) : (
				<MFAExpiredPage />
			)}
		</>
	);
};
